import { ArgosTheme, HabitatTheme } from '@sainsburys-tech/bolt/dist/es/themes/src/Themes';
export var themeContract = {
  argos: {
    success: {
      background: ArgosTheme.color.semantic.success.light,
      border: ArgosTheme.color.semantic.success.base
    },
    info: {
      background: ArgosTheme.color.semantic.info.light,
      border: ArgosTheme.color.semantic.info.base
    },
    error: {
      background: ArgosTheme.color.semantic.error.light,
      border: ArgosTheme.color.semantic.error.base
    }
  },
  habitat: {
    success: {
      background: HabitatTheme.color.semantic.success.lighter,
      border: HabitatTheme.color.semantic.success.lighter
    },
    info: {
      background: HabitatTheme.color.semantic.info.lighter,
      border: HabitatTheme.color.semantic.info.lighter
    },
    error: {
      background: HabitatTheme.color.semantic.error.lighter,
      border: HabitatTheme.color.semantic.error.lighter
    }
  }
};